"use client";

import type { ComponentProps, Key } from "react";
import { Icon, MenuDropdown, Text } from "@pamperedchef/design-system";

import { className as classNameHelper } from "@/composites/foundation/utilities/className";

import type { SortOption } from "../types";

import * as styles from "./SortControl.module.scss";

type MenuItems = ComponentProps<typeof MenuDropdown>["items"];

export interface SortControlProps {
	options: SortOption[];
	selected: string;
	onChange: (value: string) => void;
	label?: string;
	className?: string;
}

export function SortControl({
	options,
	selected,
	onChange,
	label = "Sort",
	className
}: SortControlProps): React.JSX.Element | null {
	if (options.length === 0) return null;

	const selectedIndex = Math.max(
		0,
		options.findIndex((option) => option.value === selected)
	);

	const current = `${label}: ${options[selectedIndex]?.label}`;

	function handleAction(key: Key): void {
		const option = options[Number(key)];
		if (option && option.value !== selected) onChange(option.value);
	}

	return (
		<div
			{...classNameHelper(styles.sort, className)}
			data-component="SortControl"
		>
			{options.length < 2 ? (
				<Text tag="p" className={styles.single}>
					{current}
				</Text>
			) : (
				<MenuDropdown
					items={
						options.map((option) => ({
							label: option.label
						})) as unknown as MenuItems
					}
					onAction={handleAction}
					selectionMode="single"
					selectedKeys={[String(selectedIndex)]}
					placement="bottom end"
				>
					<Icon name="filter-lines" aria-hidden />
					{current}
				</MenuDropdown>
			)}
		</div>
	);
}
